import { defaultEntityState, IEntityState } from '@core/state/entities/entity';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesByFilter,
} from '@core/state/entities/entity.helpers';
import { IStage } from '@core/state/entities/stage/stage.entity';
import { createReducer, on } from '@ngrx/store';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { entityKey } from '@core/state/entities/entity-name-map';

export const stageEntityReducer = createReducer(
  defaultEntityState<IStage>(),
  on(
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.projectUpdated,
    projectDetailActions.annotationQuestionDeleted,
    (state, props) =>
      mergeEntityState(
        entityKey.stages,
        state,
        props,
        (aq) => aq.projectId === props.projectId
      )
  ),
  on(
    projectDetailActions.stageAdded,
    projectDetailActions.stageUpdated,
    projectDetailActions.projectListingUpdated,
    projectDetailActions.stageQuestionsUpdateFailed,
    projectDetailActions.registered,
    (state, props) => mergeEntityState(entityKey.stages, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  ),
  on(
    projectDetailActions.stageWorkloadSharesUpdated,
    (state, props): IEntityState<IStage> =>
      state.byId[props.stageId]
        ? {
            ...state,
            byId: {
              ...state.byId,
              [props.stageId]: {
                ...state.byId[props.stageId],
                workloadSharesEnabled: props.workloadSharesEnabled,
              },
            },
          }
        : state
  ),
  on(projectDetailActions.updateStageQuestions, (state, props) => ({
    ...state,
    byId: {
      ...state.byId,
      [props.stage.id]: {
        ...state.byId[props.stage.id],
        annotationQuestions: props.stageQuestions,
      },
    },
  }))
);
